import { render } from "./TermConditions.vue?vue&type=template&id=17fded59&scoped=true"
import script from "./TermConditions.vue?vue&type=script&lang=js"
export * from "./TermConditions.vue?vue&type=script&lang=js"

import "./TermConditions.vue?vue&type=style&index=0&id=17fded59&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fded59"]])

export default __exports__